import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-blue border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/login"} state={{ from: location }} replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/admin/login" replace />;
  if (role === "member" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
